import {useEffect, useState, RefObject} from "react";

export const useDropdownPosition = (
    isOpen: boolean,
    containerRef: RefObject<HTMLDivElement>,
    dropdownWidth= 350
): "left" | "right" => {
    const [position, setPosition] = useState<"left" | "right">("left");

    useEffect(() => {
        if (!isOpen || !containerRef.current) return;

        const checkPosition = () => {
            const container = containerRef.current;
            if (!container) return;

            const rect = container.getBoundingClientRect();
            const viewportWidth = window.innerWidth;

            // Check if dropdown positioned on left would go off the right edge
            // rect.left is the button's left position
            // Add dropdown width to see if it would overflow
            const wouldOverflowRight = rect.left + dropdownWidth > viewportWidth - 20;

            if (wouldOverflowRight) {
                setPosition("right");
            } else {
                setPosition("left");
            }
        };

        // Small delay to ensure DOM is ready
        setTimeout(checkPosition, 0);

        // Also check on window resize
        window.addEventListener("resize", checkPosition);
        return () => window.removeEventListener("resize", checkPosition);
    }, [isOpen, containerRef, dropdownWidth]);

    return position;
};
